<template>
  <div class="box vh-140">
    <div class="box-header">
      <h3 class="box-title"><i class="fa fa-th-large"></i> {{ company.name}} - 项目列表</h3>
      <div class="box-tools">
        <el-button class="pull-right" size="mini" @click="goBack()" plain><i class="fa fa-reply"></i> 返回</el-button>
      </div>
    </div>
    <div class="box-body">
      <!-- 搜索工具栏-->
      <el-row class="margin-bottom-15" :gutter="10">
        <el-col :span="13">
          <el-button type="primary" size="small" @click="toEdit()" plain><i class="fa fa-plus"></i> 创建项目</el-button>
          <el-button size="small" @click="toAddRecharge()" plain><i class="fa fa-ra"></i> 充值</el-button>
        </el-col>
        <el-col span="5">
          <el-date-picker
              size="small"
              v-model="searchParam.date"
              type="daterange"
              style="width: 100%"
              value-format="yyyy-MM-dd 00:00:00"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="text-align-reverse">
          <el-input placeholder="请输入项目名称" v-model="searchParam.name" size="small" class="input-with-select">
            <el-button slot="append" @click="doSearch()"><i class="fa fa-search"></i> 搜索</el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-table :header-cell-style="{ background: '#eef1f6', color: '#606266' }" :data="list" border :stripe="true" style="width: 100%">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" align="center" width="60">
          <template slot-scope="scope">
            <span>{{scope.$index + page.pageSize * (page.pageNo - 1) + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" min-width="300">
          <template slot-scope="scope">
            <el-button size="medium" type="text" @click="toDetail(scope.row)">{{scope.row.name}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="目标企业" min-width="250" prop="unit"></el-table-column>
        <el-table-column label="方案类型" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.schemeType=='standard'" type="" effect="plain" size="small">标准方案</el-tag>
            <el-tag v-if="scope.row.schemeType=='person'" type="success" effect="plain" size="small">个人方案</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="方案名称" width="180" prop="schemeName"></el-table-column>
        <el-table-column label="已测人数" width="80" prop="num"></el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==0" type="warning" effect="plain" size="small">未开始</el-tag>
            <el-tag v-if="scope.row.status==1" type="" effect="plain" size="small">进行中</el-tag>
            <el-tag v-if="scope.row.status==2" type="success" effect="plain" size="small">已结束</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" width="120">
          <template slot-scope="scope">
            <span>{{formatDate(scope.row.startTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束时间" width="120">
          <template slot-scope="scope">
            <span>{{formatDate(scope.row.endTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.stop="toEdit(scope.row.id)" type="text" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button @click.native.stop="doRemove(scope.row.id)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页-->
      <page-bar v-model="page" @change="fetchData"></page-bar>
    </div>


    <!-- 修改项目编辑 -->
    <project-edit :visible="addDrawer" :projectId="echoId"  @done="finish"></project-edit>

    <!-- 修改项目编辑 -->
    <recharge-save :visible="rechargeDialog" :company-id="company.id"  @done="finish"></recharge-save>
  </div>
</template>

<script>
import {fetchCompanyAll,remove} from "@api/evaluation/project";
import {get} from '@/api/manage/company'
import sessionStorage from '@utils/store/sessionStorage'
import PageBar from "@components/PageBar";
import ProjectEdit from '@views/evaluation/ProjectEdit.vue'
import RechargeSave from '@views/manage/RechargeSave.vue'
import {handleConfirm} from '@utils/confirm'
import {parseTime} from '@/utils/index'
import { mapGetters } from 'vuex'

export default {
  created() {
    this.getCompany()
    this.fetchData()
  },
  computed: {
    ...mapGetters(['user', 'company']),
    companyId(){
      return this.$route.params.companyId
    }

  },
  components: {PageBar,ProjectEdit,RechargeSave},
  data() {
    return {
      addDrawer: false,
      rechargeDialog: false,
      page: {
        pageNo: 1,
        pageSize: 20,
        param: {}
      },
      list: [],
      company:{},
      echoId:null,
      searchParam: {
        date: '',
        startTime: '',
        endTime: '',
        name: ''
      },
    }
  },
  methods: {
    formatDate(time) {
      return parseTime(time, "{y}-{m}-{d}")
    },
    getCompany(){
      if(this.companyId){
        get(this.companyId).then(res => {
          this.company = res.data.result
        })
      }
    },
    fetchData() {
      let {pageNo,pageSize} = this.page
      let query = {pageNo,pageSize,param:{}}
      if (sessionStorage.has('project-list-search')) {
        let param = sessionStorage.get('project-list-search')
        this.searchParam = param
        query.param = param
      }

      fetchCompanyAll(this.companyId, query).then(resp => {
        this.page = resp.data.result || {}
        this.list = resp.data.result.records || []
      })
    },
    toEdit(val) {
      this.echoId = val
      this.addDrawer = true
    },
    toAddRecharge() {
      this.rechargeDialog = true
    },
    doRemove(val) {
      handleConfirm('此操作将永久删除, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.$message.success(resp.data.message)
          this.fetchData()
        })
      })
    },
    close() {
      this.dialogVisible = false
    },
    toDetail(info) {
      if (info.schemeType == 'standard'){
        this.$router.push({ path: `/evaluation/project/standard/${info.id}`})
      }else{
        this.$router.push({ path: `/evaluation/project/person/${info.id}`})
      }
    },
    doSearch() {
      let param = {...this.searchParam}
      let date = this.searchParam.date
      param.startTime = date ? parseTime(date[0]) : ''
      param.endTime = date ? parseTime(date[1]) : ''

      sessionStorage.set("project-list-search", param)
      this.fetchData();
    },
    finish(flag = false) {
      this.addDrawer = false
      this.rechargeDialog = false
      if(flag){
        this.fetchData()
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

